import axios from '../index'
import { GET_PRO_LIST } from './api'
import { HTTP_ERR_SUCCESS_MESSAGE } from '@/constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@/constant/error'

/**
 * 组织列表查询
 * @param payload
 * @param config
 * @returns {Promise<*>}
 */
export default async function getProListService(payload = {}, config = {}) {
    const param = {
        ...GET_PRO_LIST,
        ...config,
        params: payload
    }
    const { data } = await axios(param)
    if (data.message === HTTP_ERR_SUCCESS_MESSAGE) {
        return data.result
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
